
const moduleData = {
  id: "module-10",
  title: "Module 10",
  subtitle: "A Life is a Game, Play it - A digital game to test our understanding of Vedas and Vedic Living (connect Karma, Upasana and Jnana to sssso activities in the quiz)",
   cardImage: "/enBanner/m10_banner.jpg",
  pdfPath: null,
  isPdfDisabled : true,
  audio: {
    title: "Vedic Chanting - Placeholder",
    audioUrl: null,
    duration: "0:00"
  },
  video: {
    id: "g-g2_g_g_g_g"
  },
  hero: {
    title: "Module 10",
    subtitle: "A Life is a Game, Play it - A digital game to test our understanding of Vedas and Vedic Living (connect Karma, Upasana and Jnana to sssso activities in the quiz)",
    description: "Content for this module is coming soon.",
    buttonText: "Explore",
    bgImage: "/enBanner/m10_banner.jpg",
    bgAlt: "Placeholder"
  },
  pages: [
    {
      pageId: 'definition',
      title: 'Definition',
      definition: {
        sectionLabel: "Definition",
        title: "What is A Life is a Game, Play it - A digital game to test our understanding of Vedas and Vedic Living (connect Karma, Upasana and Jnana to sssso activities in the quiz)?",
        text: "Placeholder text.",
        quote: {
          sanskrit: "",
          meaning: "",
          origin: ""
        },
        description: "Placeholder description.",
        source: "",
        image: "",
        imageAlt: ""
      }
    },
    {
      pageId: 'quiz',
      title: 'Quiz',
      quiz: {
        questions: [
         
        ]
      }
    },
    {
      pageId: 'feedback',
      title: 'Feedback',
      feedback: {}
    }
  ]
};

export { moduleData };
